export const get_dynamic_options_query = `
  query Get_dynamic_options(
    $option_id: Int!
    $option_type: String!
    $amount: Float!
    $currency: String!
    $dynamic_field_name: String!
    # $country: String
  ) {
    dynamic_options(
      option_id: $option_id
      option_type: $option_type
      amount: $amount
      currency: $currency
      dynamic_field_name: $dynamic_field_name
      # country: $country
    )
  }
`;
